'use client';

import { atom, useAtom } from 'jotai';

import { Close } from '@gds/Icons/Paths/Close';
import { Typography } from '@gds/Typography/Typography';

import { SearchInfoModalMessages } from './SearchInfoModal.messages';

import styles from './SearchInfoModal.module.css';

type Props = {
  strings: SearchInfoModalMessages;
};

export const isInfoModalOpenAtom = atom(false);

export const SearchInfoModal = ({ strings }: Props) => {
  const [isInfoModalOpen, setIsInfoModalOpen] = useAtom(isInfoModalOpenAtom);

  return (
    <div
      className={styles.overlay}
      data-is-visible={isInfoModalOpen}
      onClick={() => setIsInfoModalOpen(false)}
    >
      <div className={styles.container}>
        <div className={styles.header}>
          <Typography variant="h5">{strings.title}</Typography>
          <button className={styles.closeButton} onClick={() => setIsInfoModalOpen(false)}>
            <Close />
          </button>
        </div>
        <div className={styles.content}>
          <Typography variant="body3">{strings.greeting}</Typography>
          <Typography variant="body3">{strings.developmentNotice}</Typography>
          <Typography variant="body3">{strings.betterResultsTip}</Typography>
          <ul>
            <li>{strings.searchTip1}</li>
            <li>{strings.searchTip2}</li>
            <li>{strings.searchTip3}</li>
            <li>{strings.searchTip4}</li>
            <li>{strings.searchTip5}</li>
            <li>{strings.searchTip6}</li>
          </ul>
          <Typography variant="body3">{strings.improvementMessage}</Typography>
        </div>
      </div>
    </div>
  );
};
